import { ref } from 'vue';
import { useClickOutside } from '@/composables/use-click-outside';

export const useDropdown = () => {
  const isOpen = ref(false);
  const dropdownRef = ref(null);

  const close = () => {
    isOpen.value = false;
  };

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  useClickOutside(dropdownRef, close);

  return { isOpen, dropdownRef, close, toggle };
};
